import { GlobalThemeOverrides } from "naive-ui";

const config: GlobalThemeOverrides = {
  common: {
    primaryColor: "#ffb516",
    primaryColorHover: "#ffb516",
  },
  Button: {
    textColor: "#ffb516",
  },
  Tabs: {
    tabTextColorActiveLine: "#000000FF",
    barColor: "#ffb516FF",
    tabTextColorActiveCard: "#ffb516FF",
    tabTextColorHoverBar: "#ffb516FF",
    tabTextColorActiveBar: "#ffb516FF",
    panePaddingMedium: "15px 0 0",
  },
  Calendar: {
    borderColor: "rgba(255, 255, 255, 0)",
    dateColorCurrent: "#ffc445FF",
    barColor: "#ffc445FF",
    fontSize: "18px",
    dayTextColor: "rgba(194, 194, 194, 0)",
  },
  Select: {
    peers: {
      InternalSelection: {
        textColor: "#ffb516",
      },
    },
  },
  // ...
};

export default config;
